<template>
    <div>
        <h2 class="pb-6">{{ $t('Анонсы') }}</h2>
        <div class="page-inner">
            <div class="row mt--2">
                <div class="col-lg-6" v-for="item, key in announces" :key="key">
                    <v-card :to="'/announce/view/'+item.id" class="mx-auto" elevation="1">
                        <v-img
                        :src="item.image"
                        height="200px"
                        ></v-img>

                        <v-card-title>
                            {{ item.title }}
                        </v-card-title>

                        <v-card-subtitle>
                            {{ item.created_at }}
                        </v-card-subtitle>

                        <v-card-text>
                            {{ item.anons }}
                        </v-card-text>

                        <v-card-actions>
                        <v-btn
                            color="primary"
                            text
                            small
                        >
                            {{ $t('Подробнее') }}
                        </v-btn>
                        </v-card-actions>
                    </v-card>
                </div>
                <v-progress-circular
                    v-if="isLoading"
                    indeterminate
                    :width="3"
                    class="mb-3"
                    color="primary"
                ></v-progress-circular>
            </div>
            
            <v-btn class="my-5" v-if="links && links.next" @click="getData(links.next)" depressed block color="info">{{ $t('Загрузить еще') }}</v-btn>
        </div>
    </div>
</template>
<script>
    export default {
        components: { 
        },
        mounted() {
            this.getData();
        },
        data: () => ({
            isLoading: false,
            announces: [],
            links: null
        }),
        methods: {
            async getData(url = null) {
                this.isLoading = true;
                await this.$http.get(url ?? '/announce/list').then((response) => {
                    this.announces.push(...response.data.data.data);
                    this.links = response.data.data.links;
                }).catch(() => {});
                this.isLoading = false;
            },
            handleClick(item) {
                this.$router.push({ path: '/'+this.$store.getters.getCurrentRole+'/company/'+item.bin });
            },
        },
        watch: {
            
        }
    }
</script>

<style scoped>
    .v-card__title {
        word-break: break-word;
    }
</style>